import {backUser} from "../axios";

export const authApi = [
    {url: `${backUser}/logout`, name: 'auth.logout', method: 'POST'},
    {url: `${backUser}/refresh`, name: 'auth.refresh', method: 'POST'},
    {url: `${backUser}/account`, name: 'auth.account', method: 'GET'},
]